// removed by extract-text-webpack-plugin
module.exports = {"manual":"Manual-cssmodule-manual-1RC2C","flexWrapperView":"Manual-cssmodule-flexWrapperView-1hw0a","wrapperView":"Manual-cssmodule-wrapperView-39RB6","contentView":"Manual-cssmodule-contentView-6MjSn","center":"Manual-cssmodule-center-2qWsY","content":"Manual-cssmodule-content-3csBp","media":"Manual-cssmodule-media-3GXLw","buttonView":"Manual-cssmodule-buttonView-1X9AK","button":"Manual-cssmodule-button-2qwh0","title":"Manual-cssmodule-title-3mBYh"};


//////////////////
// WEBPACK FOOTER
// ./components/ModalSet/Manual.cssmodule.less
// module id = 659
// module chunks = 0